var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"bg-blue tw-m-6 tw-mx-auto tw-my-16 tw-max-w-2xl tw-space-y-6 !tw-overflow-y-auto tw-pb-2"},[_c('ts-tes-logo',{staticClass:"tw-mx-auto tw-w-32"})],1),_vm._v(" "),_c('nuxt')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }